(function () {
    const __cmsPluginRegistry = {
        cmsRecordManagerTable: {
            path: 'record_manager/table/assets/js/tables-min.js',
            css: 'record_manager/table/assets/css/table.css',
            init: () => new window.CmsRecordManagerTable()
        },
        cmsFormsActionButton: {
            path: 'shared/Forms/js/cmsFormsActionButton-min.js',
            css: 'shared/Forms/css/cmsFormsActionButton.css'
        },
        cmsFormsProxyHelper: {
            path: 'shared/Forms/js/CmsFormsProxyHelper-min.js'
        },
        cmsForms: {
            path: 'shared/Forms/js/cmsForms-min.js',
            css: 'shared/Forms/css/cmsForms.css',
            init: () => new window.cmsForms(),
            depends: ['cmsFormsActionButton']
        },
        cmsColorPicker: {
            path: 'shared/ColorPicker/cmsColorPickerAbstraction-min.js',
            init: () => new window.cmsColorPickerAbstraction().init('cmsFrontendLoad')
        },
        cmsAccordion: {
            path: 'shared/Accordion/js/accordion-min.js',
            css: 'shared/Accordion/css/accordion.css',
            init: () => new window.CmsAccordion()
        },
        Dashboard: {
            path: 'modules/Dashboard/assets/js/Dashboard-min.js',
            css: 'modules/Dashboard/assets/css/dashboard.css',
            init: () => new window.CmsDashboardController()
        },
        Database: {
            path: 'modules/Database/assets/js/Database-min.js',
            css: 'modules/Database/assets/css/database.css',
            init: () => new window.CmsDatabaseController(),
            depends: ['cmsForms', 'cmsFormsProxyHelper']
        },
        FormThemeDesigner: {
            path: 'modules/FormThemeDesigner/assets/js/themeDesigner-min.js',
            css: 'modules/FormThemeDesigner/assets/css/themeDesigner.css',
            init: () => new window.CmsThemeDesignerController(),
            depends: ['cmsColorPicker', 'cmsForms', 'cmsAccordion']
        },
        AdminManager: {
            path: 'modules/AdminManager/assets/js/AdminManager-min.js',
            css: 'modules/AdminManager/assets/css/AdminManager.css',
            init: () => new window.CmsAdminManager(),
            depends: ['cmsForms', 'cmsRecordManagerTable']
        }
    };

    /*----------------------------------------------------------------------
        Function: loadCss cmsApp/modules/Database/assets/js/Database-min.js
    ----------------------------------------------------------------------*/
    function loadCss(cssPath) {
        const fullPath = `/${window.cmsRoutes.appDirName}/${cssPath}`;
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = `${fullPath}?v=${Date.now()}`;
        document.head.appendChild(link);
    }

    /*----------------------------------------------------------------------
        Function: loadScript
    ----------------------------------------------------------------------*/
    function loadScript(path) {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = `/cmsApp/${path}?v=${Date.now()}`;
            script.async = true;
            script.onload = resolve;
            script.onerror = () => reject(`Failed to load ${path}`);
            document.head.appendChild(script);
        });
    }

    /*----------------------------------------------------------------------
        Function: loadModule
    ----------------------------------------------------------------------*/
    async function loadModule(name, trackingSet = new Set()) {
        const mod = __cmsPluginRegistry[name];
        if (!mod || trackingSet.has(name)) return;
        trackingSet.add(name);

        if (Array.isArray(mod.depends)) {
            for (const dep of mod.depends) {
                await loadModule(dep, trackingSet);
            }
        }

        if (mod.css) loadCss(mod.css);
        if (mod.path) await loadScript(mod.path);
        if (mod.init && typeof mod.init === 'function') await mod.init();
    }

    /*----------------------------------------------------------------------
        Function: loadCmsModulesByGroup
    ----------------------------------------------------------------------*/
    async function loadCmsModulesByGroup(groupNames = []) {
        for (const name of groupNames) {
            await loadModule(name);
        }
    }

    /*----------------------------------------------------------------------
        Function: registerCmsPlugin
    ----------------------------------------------------------------------*/
    function registerCmsPlugin(name, definition) {
        __cmsPluginRegistry[name] = definition;
    }

    window.__cmsSystem = {
        init: loadCmsModulesByGroup,
        register: registerCmsPlugin
    };
})();
